import {
  IonCol, IonGrid, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption,
} from '@ionic/react';
import React, { useEffect, useState } from 'react';

import { PluginPayment, pluginPaymentOptions, WidgetSection } from '../../../../interfaces/PluginInterface/PluginInterface';
import classNames from 'classnames';
import styles from '../../Plugin.module.scss';
interface PluginFormProps {
  formData?: WidgetSection;
  handleInputUpdate: (arg0: any) => void;
}

export default function PluginFormWrapper({ formData, handleInputUpdate,
}: PluginFormProps) {

  const getSectionInput = () => {
    if (formData?.section === 'product') {
      return (
        <IonInput
          name="dom_qty"
          placeholder="Selector css para identificar la cantidad de productos"
          className={classNames(styles.pluginInput)}
          value={formData.dom_qty}
          onIonInput={(e) => handleInputUpdate(e)}
        />
      );
    } if (formData?.section === 'catalog') {
      return (
        <IonInput
          name="dom_list_item"
          placeholder="Selector css para identificar los items del listado"
          className={classNames(styles.pluginInput)}
          value={formData.dom_list_item}
          onIonInput={(e) => handleInputUpdate(e)}
        />
      );
    } if (formData?.section === 'checkout') {
      return (
        <IonSelect
          name="dom_payment_type"
          placeholder="Tipo de selector de pago"
          labelPlacement="stacked"
          interface="popover"
          className={classNames(styles.pluginInput, styles.pluginSelect)}
          value={formData.dom_payment_type}
          onIonChange={handleInputUpdate}
        >
          {pluginPaymentOptions.map((option: PluginPayment) => <IonSelectOption key={option.value} value={option.value}>{option.name}</IonSelectOption>)}
        </IonSelect>
      );
    }
  };
  const getSectionLabel = () => {
    if (formData?.section === 'product') {
      return (
        <IonLabel className={classNames(styles.labelWidgeForm)}>
          Selector css de cantidad
        </IonLabel>
      );
    } if (formData?.section === 'catalog') {
      return (
        <IonLabel className={classNames(styles.labelWidgeForm)}>
          Selector css de item de listado
        </IonLabel>
      );
    } if (formData?.section === 'checkout') {
      return (
        <IonLabel className={classNames(styles.labelWidgeForm)}>
          Tipo de selector de pago
        </IonLabel>
      );
    }
  };
  return (
    <IonGrid>
      <IonRow className={classNames(styles.pluginFormRow)}>
        <IonCol size="12" size-md="5.75">
          <IonLabel className={classNames(styles.labelWidgeForm)}>
            Selector css de página
          </IonLabel>
          <IonInput
            name="dom_page_identification"
            placeholder="Selector css para identificar la página"
            className={classNames(styles.pluginInput)}
            value={formData?.dom_page_identification}
            onIonInput={handleInputUpdate}
          />
        </IonCol>
        <IonCol size="0" size-md="0.5" />
        <IonCol size="12" size-md="5.75">
          <div className={classNames(styles.inputContainer)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>
              Selector css de observer
            </IonLabel>
            <IonInput
              name="dom"
              placeholder="Selector css para anclar el observer"
              className={classNames(
                styles.pluginInput,
                styles.widgetInput,
                styles.widgetStdInput,
              )} value={formData?.dom}
              onIonChange={(e) => {
                handleInputUpdate(e);
              }}
              onIonInput={(e: any) => {
                handleInputUpdate(e);
              }}
            />
          </div>
        </IonCol>
      </IonRow>
      <IonRow className={classNames(styles.pluginFormRow)}>
        <IonCol size="12" size-md="5.75">
          <div className={classNames(styles.inputContainer)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>
              Selector css de precio
            </IonLabel>
            <IonInput
              name="dom_var_price"
              placeholder="Selector css para identificar el precio"
              className={classNames(
                styles.pluginInput,
                styles.widgetInput,
                styles.widgetStdInput,

              )} value={formData?.dom_var_price}
              onIonInput={(e: any) => {

                handleInputUpdate(e);
              }}
            />

          </div>
        </IonCol>


        <IonCol size="0" size-md="0.5" />
        <IonCol size="12" size-md="5.75">
          {getSectionLabel()}
          {/* Selector de sección */}
          {getSectionInput()}
        </IonCol>
      </IonRow>
    </IonGrid >
  );
}
